import React from 'react'
import ResumeCard from './ResumeCard'
import {motion} from "framer-motion"

const Education = () => {
  return (
    <motion.div initial={{opacity:0}} animate={{opacity:1, transition:{duration:0.5}}} className='w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20'>
     <div className="w-full">
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px] uppercase">2021 - 2025</p>
          <h2 className="text-3xl md:text-4xl font-bold">Education Quality</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full md:w-[90%] lgl:w-full">
          <div className='border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10'>
          <ResumeCard
            title="BTech in Computer Science and Electronics"
            subTitle="Thapar Institute of Engineering and Technology, Patiala"
            result="8.71/10"
            des="Pursuing a comprehensive program covering both computer science fundamentals and electronic systems. Key coursework includes AI/ML, Data Structures & Algorithms, Database Systems, and Full-stack Development. Actively participating in tech clubs and hackathons."
          />
          <ResumeCard
            title="Higher Secondary Education"
            subTitle="BSF Sr Sec School, Jammu"
            result="95.6%"
            des="Completed with distinction in Physics, Chemistry, and Mathematics. Received merit scholarship for academic excellence. Participated in national-level science competitions."
          />
          <ResumeCard
            title="Secondary Education"
            subTitle="BSF Sr Sec School, Jammu"
            result="92.8%"
            des="Excelled in STEM subjects with honors. Recognized for outstanding performance in mathematics competitions."
          />
          </div>
        </div>
      </div>
      {/* part Two */}

      {/* <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2010 - 2022</p>
          <h2 className="text-3xl md:text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Sr. Software Engineer"
            subTitle="Google Out Tech - (2017 - Present)"
            result="USA"
            des="Google's hiring process is an important part of our culture. Googlers care deeply about their teams and the people who make them up."
          />
          <ResumeCard
            title="Web Developer & Trainer"
            subTitle="Apple Developer Team - (2012 - 2016)"
            result="MALAYSIA"
            des="A popular destination with a growing number of highly qualified homegrown graduates, it's true that securing a role in Malaysia isn't easy."
          />
          <ResumeCard
            title="Front-end Developer"
            subTitle="Nike - (2020 - 2011)"
            result="Oman"
            des="The Oman economy has grown strongly over recent years, having transformed itself from a producer and innovation-based economy."
          />
        </div>
      </div> */}
</motion.div>
  )
}

export default Education